/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiToolbarStyle = (theme: Theme): Components<Theme>["MuiToolbar"] => ({
  styleOverrides: {
    root: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      padding: "1rem",
    },
  },
});
